import { ServiceUtil as serviceUtil, userService } from './'

export const FinancialApi = {
    getFinancialInfo,
    saveFinancialInfo,
    PRIMARY_INCOME_SOURCE_EMPLOYEDFULLTIME : 1,
    PRIMARY_INCOME_SOURCE_EMPLOYEDPARTTIME : 2,
    PRIMARY_INCOME_SOURCE_SELFEMPLOYED  : 3,
    PRIMARY_INCOME_SOURCE_NOTEMPLOYED : 4,
}
 
export const FinancialService = {
  PRIMARY_INCOME_SOURCE_EMPLOYEDFULLTIME: 1,
  PRIMARY_INCOME_SOURCE_EMPLOYEDPARTTIME: 2,
  PRIMARY_INCOME_SOURCE_SELFEMPLOYED: 3,
  PRIMARY_INCOME_SOURCE_NOTEMPLOYED: 4,

  FinancialInfoFormFields: {
    1: {
      visibleFields: [
        "EmployerName",
        "Years",
        "Months",
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "IncomePerPeriod",
        "PayFrequency",
      ],
      requiredFields: [
        "EmployerName",
        "Years",
        "Months",
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "IncomePerPeriod",
        "PayFrequency",
      ],
    },
    2: {
      visibleFields: [
        "EmployerName",
        "Years",
        "Months",
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "IncomePerPeriod",
        "PayFrequency",
      ],
      requiredFields: [
        "EmployerName",
        "Years",
        "Months",
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "IncomePerPeriod",
        "PayFrequency",
      ],
    },
    3: {
      visibleFields: [
        "EmployerName",
        "Years",
        "Months",
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "IncomePerPeriod",
        "PayFrequency",
      ],
      requiredFields: [
        "Address1",
        "PostalCode",
        "State",
        "City",
        "WorkNumber",
        "Years",
        "Months",
        "IncomePerPeriod",
        "PayFrequency",
      ],
    },
    4: {
      visibleFields: ["OtherIncomeSource", "MonthlyOtherIncome"],
      requiredFields: ["OtherIncomeSource", "MonthlyOtherIncome"],
    },
  },

  PAY_FREQUENCY_WEEKLY : 1,
  PAY_FREQUENCY_BIWEEKLY : 2,
  PAY_FREQUENCY_SEMIMONTHLY : 3,
  PAY_FREQUENCY_MONTHLY: 4,
  PAY_FREQUENCY_ANNUAL : 5,
  PAY_FREQUENCY_SEMIANNUAL : 6

};



function getFinancialInfo() {
    return serviceUtil.executeServiceCall("LeadAPI", "api/FinancialBasis/Get", serviceUtil.getRequest());
}

function saveFinancialInfo(data) {
    return serviceUtil.executeServiceCall("LeadAPI", "api/FinancialBasis/Save", serviceUtil.postRequest(data));
}